import { Sun, Moon, Eye, EyeSlash, Desktop } from "@phosphor-icons/react";
import { usePrefs } from "../context/PrefsContext";

const LABELS = {
  dark: "Switch to light mode",
  light: "Switch to auto (follow OS)",
  auto: "Switch to dark mode",
};

export default function PrefsToggle() {
  const { themePref, privacy, cycleTheme, togglePrivacy } = usePrefs();
  const Icon = themePref === "dark" ? Sun : themePref === "light" ? Desktop : Moon;
  return (
    <div className="flex items-center gap-1.5" data-testid="prefs-toggle">
      <button
        type="button"
        onClick={cycleTheme}
        title={LABELS[themePref]}
        aria-label="Toggle theme"
        className="btn-ghost !py-2 !px-2.5 relative"
        data-testid="theme-toggle"
        data-theme-pref={themePref}
      >
        <Icon size={16} weight="bold" />
        {themePref === "auto" && (
          <span
            className="absolute -bottom-0.5 -right-0.5 text-[7px] font-mono font-bold leading-none bg-brand text-white px-1 py-0.5 rounded-sm"
            data-testid="auto-badge"
          >
            A
          </span>
        )}
      </button>
      <button
        type="button"
        onClick={togglePrivacy}
        title={(privacy ? "Show monetary values" : "Hide monetary values") + "  (⌘+Shift+P)"}
        aria-label="Toggle privacy"
        className={`btn-ghost !py-2 !px-2.5 ${privacy ? "!border-brand !text-brand-light" : ""}`}
        data-testid="privacy-toggle"
      >
        {privacy ? <EyeSlash size={16} weight="bold" /> : <Eye size={16} weight="bold" />}
      </button>
    </div>
  );
}
